import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

export function ProjectSelector({ projects, selectedProjectId, onSelect }) {
  return (
    <Select value={selectedProjectId || ""} onValueChange={onSelect}>
      <SelectTrigger data-testid="project-selector-dropdown" className="w-52 font-mono text-sm">
        <SelectValue placeholder="Seleccionar proyecto" />
      </SelectTrigger>
      <SelectContent>
        {projects?.map((p) => (
          <SelectItem key={p.id} value={p.id} data-testid={`project-option-${p.id}`}>
            {p.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
